var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Divider } from './Divider';
import { liStyles, selectableOptionStyles } from './styles';
const PageNumberWrapper = styled.div `
  flex: 1;
  ${({ theme: { space }, $addHorizontalPadding }) => `
    ${$addHorizontalPadding
    ? `
          padding-left: ${space.xs};
          padding-right: ${space.xs};
        `
    : ''}
  `}
`;
// The ":focus-visible, z-index 1" fixes an issue where the focus outline
// would appear behind the gray background of the selected item
const StyledAnchor = styled.a `
  ${selectableOptionStyles}

  :focus-visible {
    z-index: 1;
  }
`;
const StyledLI = styled.li `
  ${liStyles}
`;
export const PageBase = (_a) => {
    var { pageNumber, currentPage = false, onClick, ariaLabel, wide = false, excludeLeftDivider = false, excludeRightDivider = false } = _a, others = __rest(_a, ["pageNumber", "currentPage", "onClick", "ariaLabel", "wide", "excludeLeftDivider", "excludeRightDivider"]);
    const handleOnClick = e => {
        e.preventDefault();
        onClick();
    };
    return (React.createElement(StyledLI, null,
        React.createElement(StyledAnchor, Object.assign({ "$selected": currentPage, onClick: handleOnClick, "aria-label": ariaLabel, role: "link", "$wide": wide, "data-testid": `mui-pagination-${pageNumber}`, href: "" }, others),
            !excludeLeftDivider && (React.createElement(Divider, { "data-testid": `mui-pagination-${pageNumber}-left-divider` })),
            React.createElement(PageNumberWrapper, { "$addHorizontalPadding": pageNumber >= 100 }, pageNumber),
            !excludeRightDivider && (React.createElement(Divider, { "data-testid": `mui-pagination-${pageNumber}-right-divider` })))));
};
//# sourceMappingURL=PageBase.js.map